export const shows = [
  {
    id: "tv9",
    title: "长安旧梦",
    category: "tv",
    genre: "古装 / 权谋",
    region: "华语",
    year: 2025,
    rating: 9.2,
    duration: "全46集",
    releaseDate: "2025-08-16",
    director: "陶然",
    cast: ["裴照", "云若薇", "谢子昂"],
    tags: ["盛唐", "群像", "权谋"],
    summary:
      "盛世长安的繁华之下暗流涌动。一位被贬的年轻官员卷入朝堂纷争，在权力与初心之间，他必须做出选择。",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20ancient%20chinese%20historical%20drama%20poster%20of%20a%20majestic%20palace%20at%20night%20with%20glowing%20red%20lanterns%20a%20scholar%20in%20flowing%20robes%20warm%20amber%20and%20deep%20crimson%20tones%20elegant%20solemn%20mood%20detailed%20painterly%20illustration%20vertical%20composition%20no%20text&width=480&height=720&seq=cover-tv9&orientation=portrait",
    hot: 9960,
    updatedAt: "2025-08-16",
    badge: "热播",
  },
  {
    id: "tv10",
    title: "都市浮生记",
    category: "tv",
    genre: "都市 / 情感",
    region: "华语",
    year: 2024,
    rating: 8.5,
    duration: "全38集",
    releaseDate: "2024-09-10",
    director: "江野",
    cast: ["程知远", "苏念", "贺沉"],
    tags: ["职场", "现实", "群像"],
    summary:
      "五个住进同一栋老式公寓楼的年轻人，在高楼林立的城市里各自打拼。他们的焦虑、友情与爱情，拼成一幅都市浮生图鉴。",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20urban%20life%20drama%20poster%20of%20a%20young%20woman%20standing%20at%20a%20high%20apartment%20window%20overlooking%20a%20glittering%20city%20skyline%20at%20dusk%20cool%20navy%20tones%20with%20warm%20window%20lights%20cinematic%20vertical%20composition%20high%20detail%20no%20text&width=480&height=720&seq=cover-tv10&orientation=portrait",
    hot: 7480,
    updatedAt: "2024-09-10",
  },
  {
    id: "tv11",
    title: "星河学院",
    category: "tv",
    genre: "青春 / 科幻",
    region: "华语",
    year: 2025,
    rating: 8.7,
    duration: "全32集",
    releaseDate: "2025-07-05",
    director: "柏小雨",
    cast: ["洛一鸣", "安然", "宁澈"],
    tags: ["校园", "科幻", "成长"],
    summary:
      "在一所培养星际探索者的特殊学院里，一群少年用天赋与热血，学习如何在无垠宇宙中互相托付。",
    cover:
      "https://readdy.ai/api/search-image?query=futuristic%20sci%20fi%20youth%20drama%20poster%20of%20a%20gleaming%20high%20tech%20school%20campus%20with%20a%20huge%20glass%20dome%20and%20floating%20holograms%20teal%20and%20orange%20glow%20energetic%20hopeful%20mood%20clean%20digital%20illustration%20vertical%20composition%20no%20text&width=480&height=720&seq=cover-tv11&orientation=portrait",
    hot: 8230,
    updatedAt: "2025-07-05",
  },
  {
    id: "tv12",
    title: "无声证词",
    category: "tv",
    genre: "犯罪 / 悬疑",
    region: "日韩",
    year: 2024,
    rating: 8.9,
    duration: "全24集",
    releaseDate: "2024-10-18",
    director: "Hana Ito",
    cast: ["Riku Sato", "Emi Nakagawa", "Sho Watanabe"],
    tags: ["法医", "单元", "推理"],
    summary:
      "一位习惯沉默的法医，用解剖台上的每一处细节替死者发声。当旧案与新案交错，她说出的证词将撼动整个警局。",
    cover:
      "https://readdy.ai/api/search-image?query=crime%20investigation%20drama%20poster%20of%20a%20forensic%20examiner%20in%20a%20cool%20blue%20lit%20laboratory%20examining%20evidence%20under%20a%20lamp%20clinical%20teal%20and%20steel%20tones%20serious%20tense%20mood%20cinematic%20vertical%20composition%20no%20text&width=480&height=720&seq=cover-tv12&orientation=portrait",
    hot: 8060,
    updatedAt: "2024-10-18",
  },
  {
    id: "tv13",
    title: "山那边的家",
    category: "tv",
    genre: "乡村 / 温情",
    region: "华语",
    year: 2023,
    rating: 8.8,
    duration: "全30集",
    releaseDate: "2023-05-12",
    director: "田间",
    cast: ["杨守田", "周阿婆", "小豆"],
    tags: ["乡村", "治愈", "返乡"],
    summary:
      "打工多年的青年回到大山深处的老家，用一间民宿和一片果园，重新连接起被时间冲散的乡情。",
    cover:
      "https://readdy.ai/api/search-image?query=heartwarming%20rural%20life%20drama%20poster%20of%20a%20green%20mountain%20village%20with%20terraced%20fields%20and%20a%20small%20farmhouse%20under%20soft%20morning%20mist%20fresh%20green%20and%20warm%20golden%20light%20peaceful%20mood%20painterly%20illustration%20vertical%20composition%20no%20text&width=480&height=720&seq=cover-tv13&orientation=portrait",
    hot: 6420,
    updatedAt: "2023-05-12",
  },
  {
    id: "tv14",
    title: "迷雾航线",
    category: "tv",
    genre: "惊悚 / 剧情",
    region: "欧美",
    year: 2025,
    rating: 8.6,
    duration: "全10集",
    releaseDate: "2025-09-19",
    director: "Clara Jensen",
    cast: ["Adam Frost", "Nadia Reyes", "Peter Lund"],
    tags: ["货轮", "孤岛", "悬疑"],
    summary:
      "一艘驶向远洋的货轮在浓雾中偏航，船员们发现航线被悄然篡改。随着真相浮出水面，船上没有一个人是无辜的。",
    cover:
      "https://readdy.ai/api/search-image?query=thriller%20series%20poster%20of%20a%20lone%20cargo%20ship%20sailing%20through%20thick%20gray%20sea%20fog%20at%20dawn%20with%20faint%20warning%20lights%20cold%20desaturated%20blue%20and%20steel%20tones%20eerie%20tension%20cinematic%20vertical%20composition%20no%20text&width=480&height=720&seq=cover-tv14&orientation=portrait",
    hot: 8690,
    updatedAt: "2025-09-19",
    badge: "新剧",
  },
];